import React, { Component } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Menu } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import { GetForTestAndSend_Url } from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import { MESSAGE_TYPES } from "../../../provider/Enums";
class MessagePrivewDialog extends Component {
  header = store.getState().header.header;
  tollfreeNumber = store.getState().appUserData.tollfreeNumber;

  constructor(props) {
    super(props);
    this.state = {
      mmsUrl: "",
      keyword: "",
      messageName: "",
      messageType: null,
      textMessage: "",
      closingTextMessage: "",
      questionItems: [],
      currentIndex: 0,
      open: false,
    };
  }

  showMessagePreview(anchorEl, rowData) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: rowData.messageId,
      },
    };
    FetchServerData.callPostService(GetForTestAndSend_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let smsMessage = output.data.smsMessage;
          this.setState({
            textMessage: smsMessage.textMessage,
            closingTextMessage: smsMessage.closingMessage,
            questionItems: smsMessage.smsMessageQuestions,
            mmsUrl: smsMessage.mmsInfo?.mmsUrl,
            messageId: smsMessage?.id,
            messageType: smsMessage?.messageType,
            keyword: rowData?.keyword,
            messageName: rowData?.messagename,
            open: true,
            anchorEl: anchorEl,
          });
        } else {
        }
      }
    );
  }

  handleClose() {
    this.setState({ open: false });
  }
  handleNext = () => {
    const updatedMessages = [
      ...this.state.questionItems,
      {
        question: this.state.closingTextMessage,
        step: this.state.questionItems?.length + 1,
      },
    ];

    this.setState((prevState) => ({
      currentIndex: Math.min(
        prevState.currentIndex + 1,
        updatedMessages.length - 1
      ),
    }));
  };

  handlePrev = () => {
    this.setState((prevState) => ({
      currentIndex: Math.max(prevState.currentIndex - 1, 0),
    }));
  };

  render() {
    let updatedMessages = [
      ...this.state.questionItems,
      {
        question: this.state.closingTextMessage,
        step: this.state.questionItems?.length + 1,
      },
    ];
    return (
      <>
        <Menu
          anchorEl={this.state.anchorEl}
          id="dropdown-menu1"
          className="filterDropdownMenu"
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                left: 20,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "left", vertical: "top" }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        >
          <span className="closeIcon">
            <IconButton
              aria-label="close"
              onClick={this.handleClose.bind(this)}
              style={{
                position: "absolute",
                right: 4,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#000", fontWeight: "600" }} />
            </IconButton>
          </span>
          <div
            style={{
              cursor: "pointer",
              width: "400px",
              height: "100%",
              fontSize: "14px",
            }}
          >
            <div className="p-4">
              <h6 className="fw-bold mb-2 ps-3">Message Preview</h6>
              {!(
                Utils.equalsIgnoreCase(
                  this.state.messageType?.type,
                  MESSAGE_TYPES.interactive
                ) ||
                Utils.equalsIgnoreCase(
                  this.state.messageType?.type,
                  MESSAGE_TYPES.interactivePledge
                )
              ) && (
                  <>
                    <div className="col-md-12">
                      <div className="chat-bubble">
                        {Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.fundraising
                        )
                          ? this.state.amountQuestion
                          : this.state.textMessage}
                      </div>
                    </div>
                  </>
                )}
              {(Utils.equalsIgnoreCase(
                this.state.messageType?.type,
                MESSAGE_TYPES.interactive
              ) ||
                Utils.equalsIgnoreCase(
                  this.state.messageType?.type,
                  MESSAGE_TYPES.interactivePledge
                )) && (
                  <>
                    <div className="col-sm-12 mt-2">
                      <div className="chat-bubble" style={{ height: "90px" }}>
                        <span variant="body2">
                          {updatedMessages[this.state.currentIndex]?.question}
                        </span>

                        {this.state.currentIndex <
                          updatedMessages?.length - 1 && (
                            <IconButton
                              onClick={this.handleNext}
                              sx={{
                                position: "absolute",
                                bottom: 8,
                                right: 8,
                                backgroundColor: "white",
                                "&:hover": {
                                  backgroundColor: "#eee",
                                },
                              }}
                              size="small"
                            >
                              <ArrowForward fontSize="small" />
                            </IconButton>
                          )}

                        {this.state.currentIndex > 0 && (
                          <IconButton
                            onClick={this.handlePrev}
                            sx={{
                              position: "absolute",
                              bottom: 8,
                              left: 8,
                              backgroundColor: "white",
                              "&:hover": {
                                backgroundColor: "#eee",
                              },
                            }}
                            size="small"
                          >
                            <ArrowBack fontSize="small" />
                          </IconButton>
                        )}
                      </div>
                    </div>
                  </>
                )}
              {this.state.mmsUrl && (
                <>
                  <div className="col-md-12 mt-3">
                    <label
                      className="col-form-label fw-bold"
                      htmlFor="basic-default-Image"
                      id="assetFormLabel"
                    >
                      Image
                    </label>
                    <div className="col-sm-12" id="givbeeText">
                      <img
                        style={{
                          // width: "-webkit-fill-available",
                          height: "6em",
                          objectFit: "contain",
                          objectPosition: "left",
                          borderRadius: "10px",
                        }}
                        alt=""
                        src={this.state.mmsUrl ? this.state.mmsUrl : ""}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </Menu>
      </>
    );
  }
}
export default MessagePrivewDialog;
